export default __webpack_public_path__ + "static/media/spiritofyggdrasil.ae24c805.png";